export class BimBuildingCompass {
  public alphadegrees: number = -1;
  public positionX: number;
  public positionY: number;
  public positionZ: number;
}
